var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkBlack = function SvgLinkBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#333"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.59 16.824a3.414 3.414 0 0 1-2.414-5.829l1.45-1.449.965.966-1.448 1.448a2.049 2.049 0 1 0 2.897 2.898l1.448-1.449.966.966-1.449 1.449a3.393 3.393 0 0 1-2.414 1Zm.484-2.932-.966-.966 4.829-4.828.965.965-4.828 4.828v.001Zm5.312-1.448-.967-.966 1.449-1.448a2.049 2.049 0 1 0-2.897-2.898l-1.449 1.449-.966-.966 1.45-1.449a3.414 3.414 0 0 1 4.828 4.829l-1.448 1.448Z",
    fill: "#fff"
  })));
};
export default SvgLinkBlack;